import './styles.css'
import { createRouter } from './router.js'
import { shell, ensureBranding, wireShellChrome } from './ui.js'
import { renderHome, bindHome } from './pages/home.js'
import { renderCreate, bindCreate } from './pages/create.js'
import { renderAi, bindAi } from './pages/ai.js'
import { renderTicket, bindTicket } from './pages/ticket.js'
import { renderLogin, bindLogin } from './pages/login.js'
import { renderCliente, bindCliente } from './pages/cliente.js'
import { renderActivate, bindActivate } from './pages/activate.js'
import { renderDashboard, bindDashboard } from './pages/dashboard.js'
import { renderTwin, bindTwin } from './pages/twin.js'
import { renderClientCreate, bindClientCreate } from './pages/clientCreate.js'
import { renderQuoteRequest, bindQuoteRequest } from './pages/quoteRequest.js'
import { renderPendingDocs, bindPendingDocs, DOCS_PATH, LEGACY_PATH } from './pages/pendingDocs.js'
import { registerPwa, wireInstallButtons } from './pwa.js'
import { acceptInvite, apiConfigured } from './api.js'
import { initTheme } from './theme.js'
import { wireClientLoginButtons } from './loginModal.js'

const INVITE_PREFILL_KEY = 'portal_invite_prefill'

initTheme()

const app = document.getElementById('app')

const routes = [
  { path: '/', title: 'Centro de soporte', render: () => renderHome(), bind: bindHome, layout: 'home' },
  { path: '/nuevo', title: 'Nueva incidencia', render: () => renderCreate(), bind: bindCreate },
  { path: '/ia', title: 'Asistente IA', render: () => renderAi(), bind: bindAi },
  { path: '/cliente', title: 'Acceso Cliente', render: () => renderCliente(), bind: bindCliente, layout: 'login-only' },
  { path: '/entrar', title: 'Acceso Cliente', render: () => renderLogin(), bind: bindLogin, layout: 'login-only' },
  { path: '/activar', title: 'Activar acceso', render: () => renderActivate(), bind: bindActivate },
  { path: '/mi-instalacion', title: 'Mi instalación', render: () => renderDashboard(), bind: bindDashboard, layout: 'dash' },
  { path: '/mi-instalacion/gemelo', title: 'Gemelo 3D', render: () => renderTwin(), bind: bindTwin },
  {
    path: '/mi-instalacion/nueva-incidencia',
    title: 'Crear ticket',
    render: () => renderClientCreate(),
    bind: bindClientCreate,
  },
  {
    path: '/mi-instalacion/presupuesto-it',
    title: 'Solicitar presupuesto',
    render: () => renderQuoteRequest(),
    bind: bindQuoteRequest,
  },
  {
    path: DOCS_PATH,
    title: 'Mis documentos',
    render: () => renderPendingDocs(),
    bind: bindPendingDocs,
    layout: 'dash',
  },
  {
    path: LEGACY_PATH,
    title: 'Mis documentos',
    render: () => renderPendingDocs(),
    bind: bindPendingDocs,
    layout: 'dash',
  },
  {
    path: '/t/:token',
    title: 'Ticket',
    render: ({ params }) => renderTicket(params),
    bind: bindTicket,
  },
  {
    path: '/404',
    title: 'No encontrado',
    render: () => `<div class="portal-card"><h1>Página no encontrada</h1><a href="/" data-link class="portal-btn">Inicio</a></div>`,
    bind: () => {},
  },
]

async function consumeStaffHandoff() {
  const params = new URLSearchParams(window.location.search)
  const handoff = (params.get('handoff') || '').trim()
  if (!handoff || handoff.length < 32 || !apiConfigured()) return false

  try {
    const { staffHandoffExchange } = await import('./api.js')
    const { setClientSession } = await import('./clientAuth.js')
    const data = await staffHandoffExchange(handoff)
    if (!data?.ok || !data.token) return false
    setClientSession(data)
    const inst = params.get('installation_id')
    if (inst) {
      try {
        sessionStorage.setItem('portal_preferred_installation_id', inst)
      } catch (_) {}
    }
    params.delete('handoff')
    params.delete('installation_id')
    const qs = params.toString()
    window.history.replaceState({}, '', qs ? `${window.location.pathname}?${qs}` : window.location.pathname)
    return true
  } catch (_) {
    return false
  }
}

async function consumeInviteQuery(navigate) {
  const params = new URLSearchParams(window.location.search)
  const token = (params.get('invite') || '').trim()
  if (!token || token.length < 16) return false
  if (!apiConfigured()) return false

  try {
    const data = await acceptInvite(token)
    if (data?.ok) {
      const prefill = {
        company: data.organization?.name || '',
        requester_name: data.name || '',
        requester_email: data.email || '',
      }
      try {
        sessionStorage.setItem(INVITE_PREFILL_KEY, JSON.stringify(prefill))
      } catch (_) {}
      window.history.replaceState({}, '', '/nuevo')
      await navigate('/nuevo', { replace: true })
      return true
    }
  } catch (_) {}
  params.delete('invite')
  const qs = params.toString()
  window.history.replaceState({}, '', qs ? `/?${qs}` : '/')
  return false
}

const router = createRouter(routes, {
  async onResolve({ route, params }) {
    const branding = await ensureBranding()
    app.innerHTML = shell({
      title: route.title,
      bodyHtml: route.render({ params }),
      branding,
      layout: route.layout || 'default',
    })
    const ctx = { navigate: router.navigate, params }
    wireShellChrome(app, ctx)
    wireClientLoginButtons(app, ctx)
    route.bind?.(app, ctx)
    wireInstallButtons(app)
    wireInstallButtons(document)
  },
})

registerPwa()
wireInstallButtons(document)

;(async () => {
  const handoffOk = await consumeStaffHandoff()
  if (handoffOk) {
    await router.navigate('/mi-instalacion', { replace: true })
    return
  }
  const handled = await consumeInviteQuery(router.navigate)
  if (!handled) {
    await router.resolve()
  }
})()
